// 用户保单相关路由
export const UserPolicyRoutes = [
  {
    path: '/user-order',
    name: 'UserOrder',
    component: () => import('@/views/UserPolicy/Order/' /* webpackChunkName: "jincheng-yibao.user-order" */),
    meta: {
      title: '订单列表',
      needToken: true
    }
  },
  {
        path: '/user-policy/:type?',
        name: 'UserPolicy',
        component: () =>
            import (
                '@/views/UserPolicy/UserPolicy' /* webpackChunkName: "jincheng-yibao.user-policy" */
            ),
        meta: {
            title: '保单列表',
            needToken: true
        }
    },
    {
        path: '/policy-detail/:id',
        name: 'PolicyDetail',
        component: () =>
            import (
                '@/views/UserPolicy/PolicyDetail' /* webpackChunkName: "jincheng-yibao.policy-detail" */
            ),
        meta: {
            title: '订单详情',
            needToken: true
        }
    },
    {
        path: '/user-mean',
        name: 'UserMean',
        component: () =>
            import (
                '@/views/UserPolicy/UserMean' /* webpackChunkName: "jincheng-yibao.policy-detail" */
            ),
        meta: {
            title: '个人信息',
            needToken: true
        }
    },  
    {
        path: '/edit-phone',
        name: 'EditPhone',
        component: () =>
            import (
                '@/views/UserPolicy/EditPhone' /* webpackChunkName: "jincheng-yibao.policy-detail" */
            ),
        meta: {
            title: '修改手机号',
            needToken: true
        }
    }
]